import React from 'react'
import { ToastProvider as BaseToastProvider } from 'react-toast-notifications'

import useIsServer from '../../hooks/useIsServer'

import Toast from './Toast'

const ToastProvider: React.FC<{}> = ({ children }) => {
  const isServer = useIsServer()

  if (isServer) {
    return <>{children}</>
  }

  return (
    <BaseToastProvider
      placement="bottom-center"
      autoDismiss
      autoDismissTimeout={7000}
      components={{ Toast }}
    >
      {children}
    </BaseToastProvider>
  )
}

export const TestToastProvider: React.FC = ({ children }) => {
  return (
    <BaseToastProvider
      placement="bottom-center"
      autoDismiss
      autoDismissTimeout={7000}
      components={{ Toast }}
    >
      {children}
    </BaseToastProvider>
  )
}

export default ToastProvider
